var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexishowLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 576.06 170.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4,.cls-5,.cls-6{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{stroke:#d7af66;stroke-width:4px;}.cls-4,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-5{stroke:#fff;stroke-dasharray:1 1;}.cls-6{stroke:#919496;stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 576.06,
    height: 170.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 576.06,
    height: 170.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "45.82 79.41 66.9 79.41 66.9 94.26 45.82 94.26 45.82 137.17 29.49 137.17 29.49 33.24 72.69 33.24 72.69 48.09 45.82 48.09 45.82 79.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "80.56 33.24 96.89 33.24 96.89 122.32 123.77 122.32 123.77 137.17 80.56 137.17 80.56 33.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "147.22 77.04 169.64 77.04 169.64 91.89 147.22 91.89 147.22 122.32 175.43 122.32 175.43 137.17 130.89 137.17 130.89 33.24 175.43 33.24 175.43 48.09 147.22 48.09 147.22 77.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 268.45,
    y: 33.24,
    width: 16.33,
    height: 103.93
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.41,32.05c15.89,0,24,9.5,24,26.13v3.27H324V57.14c0-7.42-3-10.24-8.16-10.24s-8.17,2.82-8.17,10.24c0,21.38,31.92,25.39,31.92,55.08,0,16.63-8.31,26.13-24.35,26.13s-24.34-9.5-24.34-26.13v-6.38h15.44v7.42c0,7.43,3.26,10.1,8.46,10.1s8.46-2.67,8.46-10.1c0-21.38-31.92-25.38-31.92-55.08,0-16.63,8.17-26.13,24.05-26.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "365.3 137.17 348.96 137.17 348.96 33.24 365.3 33.24 365.3 77.78 383.85 77.78 383.85 33.24 400.48 33.24 400.48 137.17 383.85 137.17 383.85 92.63 365.3 92.63 365.3 137.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411,58.18c0-16.63,8.76-26.13,24.79-26.13s24.8,9.5,24.8,26.13v54c0,16.63-8.76,26.13-24.8,26.13S411,128.85,411,112.22Zm16.33,55.08c0,7.43,3.27,10.25,8.46,10.25s8.47-2.82,8.47-10.25V57.14c0-7.42-3.27-10.24-8.47-10.24s-8.46,2.82-8.46,10.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "507.37 81.79 501.43 137.17 479.01 137.17 467.44 33.24 483.32 33.24 492.08 115.19 499.95 33.24 515.69 33.24 523.85 115.79 532.31 33.24 546.57 33.24 534.99 137.17 513.31 137.17 507.37 81.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.55,34.14c1,11,2.57,35.71,31.76,51.29,24.07,13,31.36,30.64,32,51.55",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.09,137.8c-.23-5-.47-37.21,32.95-52.62,12.56-6.4,29.15-19.72,30.1-50.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.41,74.12c-5.54-2.11-11.92-8.47-14.13-14.38h28.26c-.76,3.58-7.68,11.76-14.13,14.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.41,110.28c7,2.64,14.94,10.62,17.71,18H204.7c1-4.48,9.62-14.74,17.71-18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 222.41,
    y1: 111,
    x2: 222.41,
    y2: 94.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 182.69,
    y1: 137.99,
    x2: 261.09,
    y2: 137.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 182.69,
    y1: 34.12,
    x2: 261.09,
    y2: 34.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexishowLogoWhite);
export default __webpack_public_path__ + "static/media/FLEXISHOW-LOGO-WHITE.c0ed290d27a65caae1dd818d2dd7f950.svg";
export { ForwardRef as ReactComponent };